// extracted by mini-css-extract-plugin
module.exports = {"root":"HospitalOrders_root__3Xl5s"};